export default __webpack_public_path__ + "static/media/english-to-vietnamese-screenshot-05.26f21caa.png";